<div class="analyst-manager">
  @if (analystViewModel().isFetching || sourcesViewModel().isFetching) {
    <div class="analyst-loading">
      <tds-icon name="progress_activity" class="spinner" data-testid="spinner" />
      <span>Loading...</span>
    </div>
  } @else {
    @for (source of whiteListedSources(); track source.id) {
      <app-analyst-section
        [source]="source"
        [analysts]="analystViewModel().analysts"
        [users]="analystViewModel().users"
      ></app-analyst-section>
    } @empty {
      <p>No source configured.</p>
    }
  }
</div>
